export default __webpack_public_path__ + "static/media/logo.b9f228ee.png";